<template>
  <PrivacySection title="13. Contatti e Reclami">
    <p>
      Per qualsiasi domanda, richiesta o reclamo relativa al trattamento dei dati personali 
      o all'esercizio dei propri diritti, l'utente può contattarci:
    </p>
    <PrivacyBox>
      <p><strong>Email:</strong> <a href="mailto:info@appscontrini.it">info@appscontrini.it</a></p>
      <p><strong>Sito web:</strong> <a href="https://www.appscontrini.it" target="_blank">www.appscontrini.it</a></p>
      <p><strong>Sezione Contatti:</strong> disponibile sul sito web e nell'applicazione</p>
    </PrivacyBox>
    <p>
      L'utente ha inoltre il diritto di proporre reclamo all'Autorità Garante per la 
      Protezione dei Dati Personali:
    </p>
    <PrivacyBox>
      <p><strong>Garante per la Protezione dei Dati Personali</strong></p>
      <p>Piazza di Monte Citorio, 121 - 00186 Roma</p>
      <p>Tel: +39 06 696771</p>
      <p>Email: <a href="mailto:garante@gpdp.it">garante@gpdp.it</a></p>
      <p>Sito web: <a href="https://www.garanteprivacy.it" target="_blank">www.garanteprivacy.it</a></p>
    </PrivacyBox>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'
import PrivacyBox from '../PrivacyBox.vue'

export default {
  name: 'ContactsSection',
  components: {
    PrivacySection,
    PrivacyBox
  }
}
</script>

